export default "__VITE_ASSET__BTzzdf2V__"